import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import Navbar from '../components/Navbar'
import DataTable from '../components/DataTable';
import context from '../context'

class Home extends Component {
  welcomeText() {
    return (
      <Fragment>
        <h1 className="pt-5 text-center">Welcome to Rahasia Saya</h1>
        <img className="mt-5 mx-auto d-block" width="500px" height="300px" src="https://i.giphy.com/media/wDGCA2dv9VJxC/giphy.webp" alt="gif"/>
      </Fragment>
    )
  }

  render() {
    return (
      <div>
        <Navbar/>
        
        <div className="mt-5">
          <context.Consumer>
            {
              data => {
                return (
                  data.user ? <DataTable {...this.props} user={data.user}/> : this.welcomeText()
                )
              }
            }
          </context.Consumer>
        </div>
      </div>
    )
  }
}

export default connect(null, null)(Home)
